<div class="wrapper" *ngIf="form; else spinner"
  [style.backgroundImage]="form.background ? 'url(data:image/jpeg;base64,'+ form.background +')' : null">
  <div class="form-container">
    <div [ngClass]="form.logoPositioning">
      <img *ngIf="form.logo && form.logoPositioning !== logoPosition.NO_LOGO" [src]="logoBase64" alt="Logo" class="logo">
      <h1 class="public-form-header">{{ form.name }}</h1>
    </div>
    <div class="panel">
      <form [formGroup]="formGroup" (ngSubmit)="submitForm()">
        <formly-form [form]="formGroup" [model]="model" [fields]="tabs" [options]="options">
        </formly-form>
      </form>
    </div>
  </div>
</div>

<ng-template #spinner>
  <div class="spinner">
    <svg width="40px" height="40px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
      <circle fill="none" stroke-width="4" stroke-linecap="round" cx="33" cy="33" r="30" class="circle"></circle>
    </svg>
  </div>
</ng-template>

